import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';
import { BuilderInfoService, CurrencyDisplayType } from '@portal/builder';

@Pipe({
  name: 'currencySymbol',
  standalone: false,
})
export class CurrencySymbolPipe implements PipeTransform {
  private readonly builderInfoService = inject(BuilderInfoService);

  transform(currencyCode: string, format: 'wide' | 'narrow' = 'narrow', locale?: string): string {
    return this.builderInfoService.settings.currencyDisplayType === CurrencyDisplayType.CODE
      ? this.builderInfoService.currency
      : this.builderInfoService.currencySymbol ||
          getCurrencySymbol(currencyCode || this.builderInfoService.currency, format, locale).replace(/(\d)/, ' $1');
  }
}
